import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import useApi from "../Api/Api";
import { FilterContext } from "../FilterContextProvider";
import Button from "../Components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import useDateSelections from "../hooks/useDateSelections";
import DateSelect from "./DateSelect";

const FilterBar = ({ handleShowFilterBar }) => {
  const api = useApi();
  const { filterData, setFilterData } = useContext(FilterContext);
  const [artists, setArtists] = useState([]);

  const { disable, setDisable } = useDateSelections();

  const { dateOptions, handleDateSelect } = useDateSelections();

  const [filter, setFilter] = useState(
    filterData || {
      artist_id: "",
      artist_name: "",
      event_id: "",
      date_button: "",
      start_date: "",
      end_date: "",
    }
  );

  const artistOptions = artists.map((artist) => ({
    label: artist.active ? artist.name : `${artist.name} (inactive)`,
    value: artist.id,
  }));

  const handleArtistSelect = (option) => {
    setDisable(false);
    setFilter({
      ...filter,
      artist_id: option.value,
      artist_name: option.label,
      event_id: "",
    });
  };

  const reset = (e) => {
    e.preventDefault();
    let all = document.getElementsByName("date");
    for (let i = 0; i < all.length; i++) all[i].checked = false;
    setDisable(true);
    setFilterData({
      artist_id: "",
      artist_name: "",
      event_id: "",
      date_button: "",
      start_date: "",
      end_date: "",
    });
    setFilter({
      artist_id: "",
      artist_name: "",
      event_id: "",
      date_button: "",
      start_date: "",
      end_date: "",
    });
  };

  const handleSubmit = (e) => {
    handleShowFilterBar();
    setFilterData({
      ...filterData,
      artist_id: filter.artist_id,
      artist_name: filter.artist_name,
      event_id: filter.event_id,
    });
    setDisable(true);
    e.preventDefault();
  };

  useEffect(() => {
    api.get(`/artists`).then((r) => {
      setArtists(r.data.filter((artist) => artist.active === true));
    });
  }, [api]);

  return (
    <div>
      <div className="fixed overflow-y-auto left-0 h-screen ml-24 w-1/3 bg-white z-10 shadow-2xl">
        <div className="flex-col px-4">
          <header className="py-6 mb-2">
            <button onClick={handleShowFilterBar} className="float-right -mt-3 text-blue-500 text-xs tracking-wide">
              <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon> Collapse
            </button>
            <div className="text-base font-semibold">Filter</div>
            <hr className="-mx-4"></hr>
          </header>
          <form id="submit" onSubmit={handleSubmit}>
            <button onClick={reset} className="float-right -mt-6 text-blue-500 text-xs tracking-wide">
              Reset
            </button>
            <div className="text-sm mb-2 font-medium">By artist</div>
            <Select
              id="artist_id"
              placeholder="Select an artist"
              className="text-xs font-light"
              options={artistOptions}
              value={artistOptions?.filter((each) => each.value === filter.artist_id)}
              onChange={(option) => handleArtistSelect(option)}
            />
            <div className="flex justify-end my-5">
              <Button
                text="Submit"
                form="submit"
                value="Submit"
                disabled={disable}
                className={disable ? "button-lg button-disabled" : "button button-lg"}
              ></Button>
            </div>
            <DateSelect
              options={dateOptions}
              onChange={handleDateSelect}
              value={dateOptions?.filter((each) => each.value === filterData.date_button)}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
